import React from 'react';
import ProblemUser from "../../../components/pages/grid/ProblemUser/ProblemUser";

const ProblemUserGridPage = () => {
    return <ProblemUser />
};

export default ProblemUserGridPage;